import { MapPin, Truck } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SERVICE_AREAS } from "@/lib/site";

export default function ServiceArea() {
  return (
    <section id="service-area" data-testid="service-area-section" className="bg-stone-950 py-24 text-stone-50 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] uppercase text-brand-bronze">
                <Truck className="h-4 w-4" aria-hidden="true" />
                Servicing Area
              </p>
              <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
                Simcoe County <span className="italic bronze-text">&amp; beyond</span>
              </h2>
              <p className="mt-6 max-w-md text-base font-light leading-relaxed text-stone-400">
                Based in Bradford, we deliver throughout Simcoe County and surrounding areas. From
                lakeshore estates to downtown rooftops and rural production sites, if your event is in the region,
                we'll reach it.
              </p>
              <p className="mt-8 inline-block border border-brand-bronze/40 px-5 py-3 text-xs font-semibold tracking-[0.2em] uppercase text-brand-bronze" data-testid="delivery-fee-note">
                Delivery fees may apply based on location
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <ul className="grid grid-cols-2 gap-x-8 sm:grid-cols-3" data-testid="service-area-list">
              {SERVICE_AREAS.map((area, i) => (
                <Reveal key={area} delay={i * 0.03}>
                  <li className="flex items-center gap-3 border-b border-stone-800 py-4 text-sm font-light tracking-wide text-stone-300">
                    <MapPin className="h-3.5 w-3.5 shrink-0 text-brand-bronze" aria-hidden="true" />
                    {area}
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.2}>
              <p className="mt-10 text-sm font-light text-stone-400">
                Outside the county? <a href="#quote" data-testid="service-area-quote-link" className="link-underline text-brand-bronze">Tell us where</a> — we regularly travel for the right event.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
